import { Box, Button, Typography } from "@mui/material";
import radioCheck from "../../assets/images/radio_empty.png";
import radioChecked from "../../assets/images/radio_checked.png";
import PropTypes from "prop-types";

export default function RecipeButton({
  selected,
  product,
  index,
  onSelectProduct,
  productApi,
}) {
  if (!product && !productApi) return null;

  return (
    <Button
      variant="text"
      onClick={() => onSelectProduct(product, index)}
      sx={{
        width: "100%",
        m: 0,
        p: "0px 0",
        backgroundColor: "transparent",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        color: "white",
        textTransform: "none",
        // Ejemplo de estilo condicional cuando está seleccionado
        ...(selected === "selected" && {
          border: "none",
          borderColor: "primary.main",
          borderRadius: "5px",
        }),
      }}
    >
      <Box sx={{ textAlign: "left" }}>
        <Typography
          variant="body1"
          sx={{
            fontSize: "14px",
            lineHeight: "14px",
            fontWeight: 500,
            mb: "3px",
          }}
        >
          {productApi?.name ? productApi.name : product.Descripcion}
        </Typography>
      </Box>
      <Box
        component="img"
        src={selected === "selected" ? radioChecked : radioCheck}
        alt="radioCheck"
        sx={{ width: "30px", height: "30px" }}
      />
    </Button>
  );
}

RecipeButton.propTypes = {
  selected: PropTypes.string,
  index: PropTypes.number,
  product: PropTypes.object,
  productApi: PropTypes.object,
  onSelectProduct: PropTypes.func,
};
